import React, { useMemo, useState } from "react";
import { Tabs } from "../../../../v2/design-system";
import { theme } from "../../../../v2/design-system/theme";
import styled from "styled-components";
import UserBasicDetails from "./UserBasicDetails";
import UserTransactionsTable from "./UserTransactionTable";

const TabsRoot = styled.div`
  .org-user-subtabs__list > div {
    gap: 9px;
    min-height: 42px;
    padding: 9px 6px 6px;
    align-items: center;
    box-sizing: border-box;
  }
  .org-user-subtabs__btn {
    min-height: 36px;
    padding: 9px 18px;
    box-sizing: border-box;
  }
`;

const PanelPad = styled.div`
  margin-top: ${theme.spacing.lg};
`;

const UserDetailsTabs = ({ user }) => {
  const [activeTab, setActiveTab] = useState("basic");

  const tabs = useMemo(
    () => [
      {
        key: "basic",
        label: "Basic details",
        content: (
          <PanelPad>
            <UserBasicDetails user={user} />
          </PanelPad>
        ),
      },
      {
        key: "transactions",
        label: "Transactions",
        content: (
          <PanelPad>
            <UserTransactionsTable user={user} />
          </PanelPad>
        ),
      },
    ],
    [user]
  );

  return (
    <TabsRoot>
      <Tabs
        variant="underline"
        activeKey={activeTab}
        onChange={(key) => setActiveTab(String(key))}
        tabs={tabs}
        tabListClassName="org-user-subtabs__list"
        tabClassName="org-user-subtabs__btn"
      />
    </TabsRoot>
  );
};

export default UserDetailsTabs;
